import { render, staticRenderFns } from "./DashboardPublic.vue?vue&type=template&id=87832a6e&scoped=true"
import script from "./DashboardPublic.vue?vue&type=script&lang=js"
export * from "./DashboardPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87832a6e",
  null
  
)

export default component.exports